/** Fallback when GET /vip/pricing fails (offline API). */
export const VIP_ORIGINAL_BRL = 12.9;
export const VIP_PROMO_BRL = 4.9;
export const VIP_DURATION_DAYS = 30;

export function formatBrl(value: number): string {
  return `R$${value.toFixed(2).replace('.', ',')}`;
}

/** Fallback discount % (matches default server seed). */
export function vipPromoPercentOffFallback(): number {
  return Math.round(((VIP_ORIGINAL_BRL - VIP_PROMO_BRL) / VIP_ORIGINAL_BRL) * 100);
}
